import React from 'react';
import { Button, ButtonProps } from '@lendi-ui/button';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

export interface NextArrowActionProps extends ButtonProps {
  customText?: string;
  isDisabled?: boolean;
}

export const NextArrowAction = (props: NextArrowActionProps) => {
  const { tracking } = useAnalytics();
  const label = props.customText || 'Next';
  return (
    <Button
      data-component={label}
      type={'submit'}
      {...props}
      onClick={run(props.onClick, () => tracking?.button[props.variant]({ text: label }))}
    >
      {label}
    </Button>
  );
};
